import dayjs from 'dayjs'
import conversionUtcDate from 'src/utils/conversionUtcDate'
import { getSmsChatSummary, getSmsChatDetail } from '/src/@api/dashboard'
import { generateMockData } from 'src/utils'
import { getUserAccountOrder } from 'src/@api/login'
import { createDeviceScopedChatSlice } from 'src/store/apps/createDeviceScopedChatSlice'
import { buildTimeParams } from 'src/utils/dateRangeParams'

const readDeviceSnapshot = () => ({
  deviceUser: JSON.parse(localStorage.getItem('DeviceUser') || '{}'),
  currentDevice: JSON.parse(localStorage.getItem('currentDevice') || '{}')
})

const mapDetail = item => ({
  ...item,
  time: conversionUtcDate(item.date, 'local', 'YYYY-MM-DD HH:mm'),
  defaultAvata: '/images/avatars/10.png'
})

const loadSummary = async ({ page, range }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const username = deviceUser?.username || ''
  const deviceUdid = currentDevice?.['Unique Identifier'] || ''
  const orders = await getUserAccountOrder({ page: 1, pageSize: 10 })
  const lastOrder = orders.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]
  const response = await getSmsChatSummary({
    username,
    params: {
      category: 'SMS_CHAT_SUMMARY',
      offset: (page - 1) * 50,
      limit: 50,
      deviceUdid,
      // 日期筛选走接口：带 startTime/endTime 时服务端按时间过滤
      ...buildTimeParams(range)
    }
  })
  let data = response.data.contents?.map(item => ({
    ...item,
    time: conversionUtcDate(item.snippetTimestamp, 'local', 'YYYY-MM-DD'),
    defaultAvata: '/images/avatars/10.png'
  })) || []
  const advanced = username == null || !('advanced' in response) || [true, 'true'].includes(response?.advanced)
  if (!advanced) data = generateMockData(data)

  let defaultSelectData = []
  if (page === 1 && data[0]) {
    const detail = await getSmsChatDetail({
      username,
      params: { category: 'SMS_CHAT_DETAIL', offset: 0, limit: 50, deviceUdid, rid: data[0].guid }
    })
    defaultSelectData = detail.data.contents?.map(mapDetail) || []
  }

  return {
    data,
    defaultSelectData,
    leftTotalCount: response.data.totalCount,
    advanced,
    replaceList: !advanced,
    nextLeftPage: advanced ? page : 0
  }
}

const loadDetail = async ({ contact, page, range }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const response = await getSmsChatDetail({
    username: deviceUser?.username || '',
    params: {
      category: 'SMS_CHAT_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      deviceUdid: currentDevice?.['Unique Identifier'] || '',
      rid: contact.guid,
      ...buildTimeParams(range)
    }
  })

  return {
    selected: response.data.contents?.map(item => ({ ...mapDetail(item), defaultAvata: '/images/avatars/1.png' })) || [],
    rightTotalCount: response.data.totalCount
  }
}

const chat = createDeviceScopedChatSlice({
  sliceName: 'TextMessages',
  storeKey: 'TextMessages',
  actionPrefix: 'textMessages',
  contactKey: 'guid',
  storageKey: 'smsItem',
  loadSummary,
  loadDetail,
  createExtraState: () => ({ advanced: true }),
  applySummary: (state, payload) => {
    state.advanced = [true, 'true'].includes(payload.advanced)
  }
})

export const fetchUserProfile = chat.fetchSummary
export const selectMessage = chat.selectDetail
export const removeSelectedChat = chat.removeSelectedChat
export const setMessageDateRange = chat.setDateRange
export default chat.reducer
